export enum leadCenterTypeEnum {
    SENIOR = 'senior',
    PARALLEL = 'parallel',
    UPLYFT = 'uplyft',
    ADVERSUS = 'adversus',
}
